"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M18 20.188L36 6.665v-1.5A1.146 1.146 0 0 0 34.875 4H1.125A1.147 1.147 0 0 0 0 5.167v1.469zm6.779-2.225L36 26.367V9.541l-11.221 8.422z" }),
  React.createElement("path", { d: "M22.866 19.4l-3.576 2.694a2.171 2.171 0 0 1-2.58 0l-3.628-2.719L0 29.068v1.765A1.147 1.147 0 0 0 1.125 32h33.75A1.146 1.146 0 0 0 36 30.834v-1.59zm-11.701-1.462L0 9.512v16.683l11.165-8.257z" })
);

